import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { QUIZ } from "@/theme/quizTokens";

type ValueItem = {
    lead: string;
    body: string;
};

const items: ValueItem[] = [
    {
        lead: "Less in the bin.",
        body: "Bowls licked clean means you're not paying for food that gets scraped away.",
    },
    {
        lead: "You feed less of it.",
        body: "It's complete and balanced, so there's nothing to top up.",
    },
    {
        lead: "No supplement to buy.",
        body: "The superfood blend is already in every meal.",
    },
    {
        lead: "Better food now, fewer stressful vet visits later.",
        body: "No guarantees, but it's common sense that great quality, healthy food can save stress down the road.",
    },
];

export default function PlanValueBlock() {
    return (
        <Box sx={{ width: "100%", bgcolor: QUIZ.color.cream, py: { xs: "32px", md: "36px" } }}>
            <Box sx={{ width: "100%", maxWidth: { xs: "100%", sm: 520, md: 960 }, mx: "auto", px: { xs: "28px", md: 0 } }}>
                {/* "STRAIGHT TALK" label */}
                <Typography
                    sx={{
                        fontFamily: QUIZ.font.button,
                        fontWeight: 700,
                        fontSize: { xs: 13, md: 18 },
                        letterSpacing: "1px",
                        textAlign: "center",
                        color: QUIZ.color.brown,
                        mb: 1,
                    }}
                >
                    STRAIGHT TALK
                </Typography>

                {/* Heading */}
                <Typography
                    component="h2"
                    sx={{
                        fontFamily: QUIZ.font.display,
                        fontWeight: 900,
                        textTransform: "uppercase",
                        textAlign: "center",
                        color: QUIZ.color.brown,
                        fontSize: { xs: 30, md: 38 },
                        lineHeight: 1.15,
                        mb: { xs: 2, md: 3 },
                    }}
                >
                    What makes Paws great value
                </Typography>

                {/* Intro paragraph */}
                <Typography
                    sx={{
                        fontFamily: QUIZ.font.body,
                        fontSize: { xs: 13.5, md: 18 },
                        lineHeight: 1.6,
                        color: QUIZ.color.brown,
                        textAlign: "center",
                        maxWidth: { md: 700 },
                        mx: { md: "auto" },
                        mb: { xs: 3, md: 4 },
                    }}
                >
                    We're not the cheapest dog food out there. We've never tried to be.
                    We think the right goal is proper food at a fair price, made by
                    people who'd feed it to their own dogs.
                </Typography>

                {/* Checklist */}
                <Box sx={{ display: { xs: "flex", md: "grid" }, flexDirection: "column", gridTemplateColumns: { md: "repeat(2, minmax(0, 1fr))" }, columnGap: { md: "48px" }, rowGap: { md: "32px" }, gap: { xs: "20px" } }}>
                    {items.map((item) => (
                        <Box
                            key={item.lead}
                            sx={{ display: "flex", alignItems: "flex-start", gap: { xs: "12px", md: "16px" } }}
                        >
                            <Box
                                sx={{
                                    flexShrink: 0,
                                    width: { xs: 24, md: 28 },
                                    height: { xs: 24, md: 28 },
                                    borderRadius: "50%",
                                    bgcolor: QUIZ.color.brown,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mt: "2px",
                                }}
                            >
                                <CheckIcon sx={{ color: QUIZ.color.green, fontSize: { xs: 16, md: 18 } }} />
                            </Box>
                            <Typography
                                sx={{
                                    fontFamily: QUIZ.font.body,
                                    fontSize: { xs: 15, md: 17 },
                                    lineHeight: 1.5,
                                    color: QUIZ.color.brown,
                                }}
                            >
                                <Box component="span" sx={{ fontWeight: 620, display: { md: "block" }, mb: { md: "4px" } }}>
                                    {item.lead}
                                </Box>{" "}
                                {item.body}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}
